import i18n from 'config/i18n';
import * as yup from 'yup';

import { formattedHoursMinutesToSeconds, getLocale } from 'utils/date';
import dayjs from 'dayjs';

const formattedTimeInputSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    duration: yup
      .string()
      .default('00u00')
      .typeError(t('invalidFormattedTimeValue'))
      .required(t('validationFieldRequired', { name: t('duration') }))
      .test(
        'formatted-time-duration',
        (value: string, ctx: yup.TestContext) => {
          const duration = formattedHoursMinutesToSeconds(value);
          const twentyFourHoursInSeconds =
            dayjs(0).add(24, 'hours').valueOf() / 1000;
          const oneHourInSeconds = dayjs(0).add(60, 'minutes').valueOf() / 1000;

          const isHours =
            !!duration && duration >= 0 && duration <= twentyFourHoursInSeconds;
          const isMinutes =
            !!duration && duration >= 1 && duration <= oneHourInSeconds;

          switch (true) {
            case /^\d*$/gi.test(value):
            case /^\d{1,2}u\d{2}$/gi.test(value):
              return isHours;
            case /^\d{1,2}min$/gi.test(value):
              return isMinutes;
            default:
              return ctx.createError({
                message: t('invalidFormattedTimeValue'),
                path: 'duration'
              });
          }
        }
      )
  });
};

export default formattedTimeInputSchema;
